import axios from 'axios';
import _this from './../main';
import router from './../router/index';
import qs from 'qs';
let baseURL;
if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://dengji.local.com/v1/';
  // baseURL = 'https://kaoshi.dyi123.com/v1/';
  
} else {
  baseURL = '/v1/';
}
let instance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  withCredentials: false,
});
let myInterceptor;
// 添加请求拦截器
instance.interceptors.request.use(
  function(config = {}) {
    if (config.method === 'post') {
      if (config.data instanceof FormData) {
        return config;
      } else {
        config.data = qs.stringify({
          ...config.data,
          token: localStorage.getItem('token'),
        });
        return config;
      }
    }
    if (localStorage.getItem('token')) {
      // config.headers.token = localStorage.getItem('token');
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
myInterceptor = instance.interceptors.response.use(
  function(response) {
    if (response.data.status === 0) {
      _this.$message.warning(response.data.msg);
      // 登录过期
      if (response.data.error_code === '403') {
        if (localStorage.getItem('token')) {
          localStorage.removeItem('token');
          router.push({ path: '/login', query: { back: _this.$route.path } });
        }
      }
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  },
);
export default instance;
